<div *ngIf="!noData">
    <label cvLocalizedText langSection="Date_Paradigm_Filter" langKey="Date_Paradigm">DATE PARADIGM</label>
    <cxone-singleselect-dropdown
        class="singleSelect"
        [(ngModel)]="selectedOption"
        [options]="dateParadigmOptions"
        [label]="'DisplayName'"
        [primaryKey]="'Name'"
        (selectionChanged)="selectedOptionChanged($event)">
    </cxone-singleselect-dropdown>
</div>
